import { render, staticRenderFns } from "./ExportVolDetail.vue?vue&type=template&id=1dab55f2&scoped=true"
import script from "./ExportVolDetail.vue?vue&type=script&lang=js"
export * from "./ExportVolDetail.vue?vue&type=script&lang=js"
import style0 from "./ExportVolDetail.vue?vue&type=style&index=0&id=1dab55f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dab55f2",
  null
  
)

export default component.exports